import * as _ from 'lodash';

export function getFieldValue(source, mapping, fieldName, defaultValue = null) {
  const propertyPath = mapping?.[fieldName];
  if (!propertyPath) {
    return defaultValue;
  }

  return _.get(source, propertyPath, defaultValue);
}

export function safeHref(url) {
  if (!url || !`${url}`.trim()) return null;
  try {
    const parsed = new URL(url, window.location.origin);
    if (!['http:', 'https:', 'mailto:'].includes(parsed.protocol)) return null;
    return parsed.toString();
  } catch {
    return null;
  }
}
